export default __webpack_public_path__ + "static/media/about2.8027fb4e.png";